import { NAVBAR_ROUTES } from '@web-app/components/consts';
import {
  FeatureFlags,
  NavbarSkeletonsProps,
} from '@web-app/components/Navbar/types';
import { shouldShowRoute } from '@web-app/components/Navbar/utils';

export const NavbarSkeletons = ({
  settingsPageAccess,
  managePracticeDashboard,
  calendarEnabled,
  performanceDashboard,
  showInternalTools,
  supervisionTasks,
  isBerryStreetOnly,
  groupPracticeInvoiceEnabled,
  w9PageEnabled,
  confirmCancellationEnabled,
  additionalBenefitsCheckEnabled,
  chatEnabled,
  navEntries,
  subOrgsInvoiceReviewEnabled,
  nonAppointmentHoursEnabled,
  inSessionTemplatesNavEnabled,
  documentsNavEnabled,
  isPrescriber,
  prescriptionTasksEnabled,
  hasAccessNpReviewQueue,
}: NavbarSkeletonsProps): JSX.Element => {
  const featureFlags: FeatureFlags = {
    settingsPageAccess,
    managePracticeDashboard,
    calendarEnabled,
    performanceDashboard,
    showInternalTools,
    isSupervisor: true, // Assume true for skeleton display
    supervisionTasks,
    isBerryStreetOnly,
    groupPracticeInvoiceEnabled,
    w9PageEnabled,
    confirmCancellationEnabled,
    additionalBenefitsCheckEnabled,
    chatEnabled,
    navEntries,
    subOrgsInvoiceReviewEnabled,
    nonAppointmentHoursEnabled,
    inSessionTemplatesNavEnabled,
    documentsNavEnabled,
    isPrescriber,
    prescriptionTasksEnabled,
    hasAccessNpReviewQueue,
  };

  const renderSkeleton = (key: string) => (
    <div
      key={key}
      className="h-10 w-full animate-pulse rounded-[10px] bg-sidebar-accent"
    />
  );

  return (
    <>
      {NAVBAR_ROUTES.map((route) => {
        if (!shouldShowRoute(route, featureFlags)) {
          return null;
        }

        // Route with children - show skeleton for parent only (collapsed state)
        if (route.children && route.children.length > 0) {
          const hasVisibleChildren = route.children.some((child) =>
            shouldShowRoute(child, featureFlags),
          );
          if (!hasVisibleChildren) {
            return null;
          }
          return renderSkeleton(route.path);
        }

        return renderSkeleton(route.path);
      })}
    </>
  );
};
